import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from '../../Config/environment';

export default function ArticlePost({
  title,
  imageUrl,
  createdAt,
  id
}) {

  const formattedDate = createdAt
    ? new Date(createdAt).toLocaleDateString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
    : "";
console.log("imageUrl444",imageUrl);

  return (
    <div className="cs_post cs_style_1">
      <Link to={`/article/${id}`}>
        {imageUrl?.length > 0 ? (
          <div className="flex flex-wrap gap-4">
            {imageUrl.map((img, i) =>{
              return(
              <img
                key={i}
                src={+-
                  img?.startsWith("http")
                    ? img
                    : `${API_URL}/uploads/healthArticles/${img}`
                }
                alt={title}
                className="w-full rounded-xl shadow-sm"
              />
            )})}
          </div>
        ) : (
          <img
            src="/placeholder.jpg"
            alt={title}
            className="w-full rounded-xl shadow-sm"
          />
        )}
      </Link>


      <div className="cs_post_info">
        <div>
          <div className="cs_post_meta">
            <div className="cs_posted_by">
              {formattedDate}
            </div>

            {title && (
              <div className="cs_post_social">
                <Link to="/" className="cs_center rounded-circle">
                  <Icon icon="fa-brands:linkedin-in" />
                </Link>
                <Link to="/" className="cs_center rounded-circle">
                  <Icon icon="fa-brands:facebook-f" />
                </Link>
                <Link to="/" className="cs_center rounded-circle">
                  <Icon icon="fa-brands:twitter" />
                </Link>
              </div>
            )}
          </div>

          <h2 className="cs_post_title cs_semibold cs_fs_32">
            <Link to={`/article/${id}`}>
              {title}
            </Link>
          </h2>
        </div>

        {title && (
          <div className="cs_heading_color cs_medium">
            <Link to={`/article/${id}`} className="cs_post_btn">
              Read more
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
